import Layout from '@/layout';

import Monitor from './monitor.js';
import Record from './record.js';
import Statistics from './statistics.js';

export { Monitor, Record, Statistics };

export const FirefightingRoutes = {
  path: '/firefighting',
  component: Layout,
  meta: {
    title: '天津消防',
    icon: 'iconfont icon-shexiangtou',
    code: '010219'
  },
  children: [
    {
      path: '',
      name: 'firefightingIndex',
      redirect: '/firefighting/monitor',
      component: () => import('@/views/firefighting/index.vue'),
      meta: {
        activeMenu: '/firefighting',
        noPadding: true
      },
      children: [...Monitor, ...Record, ...Statistics]
    },
    {
      path: '*',
      component: () => import('@/views/404')
    }
  ]
};
